import { gql } from '@apollo/client';

export const NAME_VALUE_FRAGMENT = gql`
  fragment NameValueFields on GenericAttributeType {
    name
    value
  }
`;

export const SALT_ITEM_BRAND_INFO_FIELDS_FRAGMENT = gql`
  fragment ItemContext_ItemBrandInfoFields on BrandInformationType {
    additionalInformation {
      ...NameValueFields
    }
    brandName
    manufacturer
  }

  ${NAME_VALUE_FRAGMENT}
`;

export const SALT_ITEM_DIETARY_INFO_FIELDS_FRAGMENT = gql`
  fragment ItemContext_ItemDietaryInfoFields on DietaryInformationType {
    additionalInformation {
      ...NameValueFields
    }
    allergens {
      containmentLevel
      name
    }
    dietTypes {
      ...NameValueFields
    }
    ingredients
    nutrients {
      additionalInformation {
        ...NameValueFields
      }
      amount
      name
      percentDv
      unitName
    }
  }

  ${NAME_VALUE_FRAGMENT}
`;

export const SALT_ITEM_PACKAGING_AND_STORAGE_FRAGMENT = gql`
  fragment ItemContext_ItemPackagingAndStorageFields on PackagingAndStorageType {
    packaging {
      additionalInformation {
        ...NameValueFields
      }
      grossWeight
      netWeight
      packHeight
      packLength
      packWidth
    }
    storage {
      ...NameValueFields
    }
  }

  ${NAME_VALUE_FRAGMENT}
`;

export const SALT_BASE_ITEM_FIELDS_FRAGMENT = gql`
  fragment ItemContext_SaltBaseItemFields on ItemInfoWithVpUuidType {
    basicInformation {
      descriptions {
        ...NameValueFields
      }
      names {
        ...NameValueFields
      }
    }
    images {
      uri
    }
  }

  ${NAME_VALUE_FRAGMENT}
`;

export const SALT_ITEM_FIELDS_FRAGMENT = gql`
  fragment ItemContext_SaltItemFields on ItemInfoWithVpUuidType {
    ...ItemContext_SaltBaseItemFields
    basicInformation {
      additionalInformation {
        ...NameValueFields
      }
    }
    brandInformation {
      ...ItemContext_ItemBrandInfoFields
    }
    categories {
      level
      name
      type
    }
    dietaryInformation {
      ...ItemContext_ItemDietaryInfoFields
    }
    packagingAndStorage {
      ...ItemContext_ItemPackagingAndStorageFields
    }
    servingAndPreparation {
      serving {
        ...NameValueFields
      }
      preparation {
        ...NameValueFields
      }
    }
  }

  ${NAME_VALUE_FRAGMENT}
  ${SALT_BASE_ITEM_FIELDS_FRAGMENT}
  ${SALT_ITEM_BRAND_INFO_FIELDS_FRAGMENT}
  ${SALT_ITEM_DIETARY_INFO_FIELDS_FRAGMENT}
  ${SALT_ITEM_PACKAGING_AND_STORAGE_FRAGMENT}
`;
